const doc = [({"en":({"js":({"admin":({"surveys":({"activation_button":({"activated":"Activated", "deactivated":"Deactivated"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;